/**
 * @author Bruce
 * @time 2019/4/9
 * @description 数字操作相关工具方法
 */

export default {
  /**
   * 小数转化成百分数
   */
  toPercent(val) {
    return Number(val * 100).toFixed(2) + "%";
  },
  /**
   * 过滤手机号，将手机号变成中间四位*
   */
  filtMobile(val) {
    val = val + '';
    return val.substr(0, 3) + "****" + val.substr(7);
  },
  /**
   * 过滤首位是0的数字，第一位不能是0
   * @param val 
   */
  filtFirstZero(val) {
    let res = val;
    let reg = /^[1-9]\d*$/;
    if (!reg.test(val)) {
      res = val.replace(/^0/g, "");
    }
    return res;
  },
  /**
   * 将毫秒数转为对应的时分秒
   */
  toHMS(val) {
    let totalSeconds = parseInt(val / 1000);
    let hour = parseInt(totalSeconds / 3600); // 剩余多少小时
    let minute = parseInt((totalSeconds % 3600) / 60); // 剩余多少分钟
    let second = parseInt((totalSeconds % 3600) % 60); // 剩余多少秒
    if (hour < 10) {
      hour = "0" + hour;
    }
    if (minute < 10) {
      minute = "0" + minute;
    }
    if (second < 10) {
      second = "0" + second;
    }
    return {
      hour: hour,
      minute: minute,
      second: second
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/numberUtils.js